export default __webpack_public_path__ + "static/media/youtube.a4b85867.svg";